import { Controller } from "stimulus";

// Abre en pantalla completa la imagen de fondo del parallax o una imagen de un popup
// (con data-image-url) al hacer clic. Reutiliza el mismo modal que activeOffice_controller.js.
export default class extends Controller {
    connect() {
        this.handleClick = this.showFullscreenImage.bind(this);
        this.element.addEventListener('click', this.handleClick);
    }

    disconnect() {
        this.element.removeEventListener('click', this.handleClick);
        this.hideFullscreenImage();
    }

    showFullscreenImage(event) {
        // Imagen de un popup (data-image-url) o, si no, la del parallax
        const clicked = event && event.target;
        const fromPopup = clicked && clicked.dataset ? clicked.dataset.imageUrl : null;
        const officeName = clicked && clicked.dataset ? clicked.dataset.officeName : null;
        const imageUrl = fromPopup || this.element.dataset.parallaxImg;
        if (!imageUrl) return;

        this.hideFullscreenImage();

        const backdrop = document.createElement('div');
        backdrop.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.9);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            cursor: zoom-out;
        `;
        backdrop.onclick = this.hideFullscreenImage.bind(this);

        const imgContainer = document.createElement('div');
        imgContainer.style.cssText = `
            max-width: 90vw;
            max-height: 90vh;
            overflow: auto;
        `;

        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = officeName || 'Vista completa';
        img.style.cssText = `
            max-width: 100%;
            max-height: 100%;
            display: block;
            box-shadow: 0 0 20px rgba(0,0,0,0.5);
        `;

        const closeBtn = document.createElement('div');
        closeBtn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            background: rgba(255,255,255,0.8);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            z-index: 10000;
            font-size: 24px;
            color: #333;
        `;
        closeBtn.innerHTML = '&times;';
        closeBtn.onclick = function (e) {
            e.stopPropagation();
            this.hideFullscreenImage();
        }.bind(this);

        imgContainer.appendChild(img);
        backdrop.appendChild(imgContainer);
        backdrop.appendChild(closeBtn);
        document.body.appendChild(backdrop);

        this.fullscreenModal = backdrop;
    }

    hideFullscreenImage() {
        if (this.fullscreenModal) {
            this.fullscreenModal.remove();
            this.fullscreenModal = null;
        }
    }
}
